<template>
  <div
    class="bg-white rounded-2xl px-3 py-3 mb-2 cursor-pointer active:scale-[0.98] transition-transform"
    @click="$emit('select', product)"
  >
    <!-- Название — на всю ширину -->
    <p class="text-15 font-normal text-ink leading-snug">
      {{ product.name }}
    </p>

    <!-- Пилюли КБЖУ + бейдж источника -->
    <div class="flex items-end justify-between mt-1.5">
      <div class="flex flex-wrap gap-1.5">
        <span class="pill-kcal">{{ fmtVal(product.kcal) }} ккал</span>
        <span class="pill-protein">{{ fmtVal(product.protein) }} г</span>
        <span class="pill-fat">{{ fmtVal(product.fat) }} г</span>
        <span class="pill-carbs">{{ fmtVal(product.carbs) }} г</span>
      </div>

      <!-- Бейдж источника — правый нижний угол -->
      <span
        v-if="sourceBadge"
        class="text-11 font-medium shrink-0 ml-2"
        :style="{ color: sourceBadge.color }"
      >
        ✓ {{ sourceBadge.label }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  product: { type: Object, required: true },
})

defineEmits(['select'])

function fmtVal(val) {
  if (val === null || val === undefined) return '0'
  const n = parseFloat(val)
  if (isNaN(n)) return '0'
  return n % 1 === 0 ? String(n) : n.toFixed(1)
}

const sourceBadge = computed(() => {
  const s = (props.product.source || '').toLowerCase()
  if (s.includes('скурихин') || s.includes('skurikhin')) {
    return { label: 'Скурихин', color: '#2D6A4F' }
  }
  if (s.includes('usda')) {
    return { label: 'USDA', color: '#1A5A7A' }
  }
  if (props.product.is_own) {
    return { label: 'Добавлено мной', color: '#7A6B5D' }
  }
  return null
})
</script>

<style scoped>
.pill-kcal    { background: #EE998C; border-radius: 8px; padding: 2px 8px; font-size: var(--fs-12); font-weight: 500; color: var(--ink); }
.pill-protein { background: #9FC2C1; border-radius: 8px; padding: 2px 8px; font-size: var(--fs-12); font-weight: 500; color: var(--ink); }
.pill-fat     { background: #EBC06D; border-radius: 8px; padding: 2px 8px; font-size: var(--fs-12); font-weight: 500; color: var(--ink); }
.pill-carbs   { background: #EEAD77; border-radius: 8px; padding: 2px 8px; font-size: var(--fs-12); font-weight: 500; color: var(--ink); }
</style>
